import moment from "moment";

import { LogEventTypeEnum } from "@/Administration/Models/Enums/LogEventTypeEnum";
import { CostCenterUIModel } from "@/Administration/Models/UI/CostCenterUIModel";
import { SearchMenuHelper } from "@/Common/Helpers/SearchMenuHelper";
import { EmployeeUIModel } from "@/Common/Models/UI/Employee/EmployeeUIModel";
import { CheckboxTarget } from "@/Common/Models/UI/Inputs/CheckboxTarget";
import { CheckboxUIModel } from "@/Common/Models/UI/Inputs/CheckboxUIModel";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper, ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { AdministrationHelper } from "../Helpers/AdministrationHelper";
import { IBillableServiceModel } from "../Models/UI/BillableService/IBillableServiceModel";
import { IExternalConsultationHistoryGridModel } from "../Models/UI/ExternalConsultationHistory/IExternalConsultationHistoryGridModel";
import { IGroupTabModel } from "../Models/UI/Group/IGroupTabModel";
import { ILogTabModel } from "../Models/UI/Logs/ILogTabModel";
import { IServiceComboGridModel } from "../Models/UI/ServiceCombo/IServiceComboGridModel";
import { ISiteCreateModel, SiteCreateModel } from "../Models/UI/Sites/ISiteCreateModel";
import { ISitesTabModel, SiteTabModel } from "../Models/UI/Sites/ISitesTabModel";
import { ISiteViewModel, SiteViewModel } from "../Models/UI/Sites/ISiteViewModel";
import { IAdminTabModel } from "../Models/UI/Tabs/IAdminTabModel";
import { IUsersTabModel } from "../Models/UI/Users/IUsersTabModel";
import { AdministrationBillableServiceAction } from "./Actions/AdministrationBillableServiceAction";
import { AdministrationGroupAction } from "./Actions/AdministrationGroupAction";
import { AdministrationLogAction } from "./Actions/AdministrationLogAction";
import { AdministrationUsersAction } from "./Actions/AdministrationUsersAction";
import { ServiceComboAdministrationAction } from "./Actions/ServiceComboAdministrationAction";
import { SitesTabAction } from "./Actions/SitesTabAction";
import { AdministrationBillableServiceHandler } from "./Handlers/Local/AdministrationBillableServiceHandler";
import { AdministrationGroupHandler } from "./Handlers/Local/AdministrationGroupHandler";
import { AdministrationLogHandler } from "./Handlers/Local/AdministrationLogHandler";
import { AdministrationTabHandler } from "./Handlers/Local/AdministrationTabHandler";
import { AdministrationUsersHandler } from "./Handlers/Local/AdministrationUsersHandler";
import { AdministrationXComLogHandler } from "./Handlers/Local/AdministrationXComLogHandler";
import { ServiceComboHandler } from "./Handlers/Local/ServiceComboHandler";
import { SitesTabHandler } from "./Handlers/Local/SitesTabHandler";
import { AdministrationBillableServiceResponseHandler } from "./Handlers/Server/AdministrationBillableServiceResponseHandler";
import { AdministrationGroupResponseHandler } from "./Handlers/Server/AdministrationGroupResponseHandler";
import { AdministrationLogResponseHandler } from "./Handlers/Server/AdministrationLogResponseHandler";
import { AdministrationUsersResponseHandler } from "./Handlers/Server/AdministrationUsersResponseHandler";
import { ServiceComboResponseHandler } from "./Handlers/Server/ServiceComboResponseHandler";
import { SitesTabResponseHandler } from "./Handlers/Server/SitesTabResponseHandler";

let defaultInstance: AdministrationStore;

class AdministrationStore extends BaseStore {
    private mapper: RequestMapper;
    private serverMapper: ServerResponseMapper;

    private serviceComboHandler: ServiceComboHandler;
    private serviceComboResponseHandler: ServiceComboResponseHandler;
    private usersHandler: AdministrationUsersHandler;
    private grouphandler: AdministrationGroupHandler;
    private usersResponseHandler: AdministrationUsersResponseHandler;
    private groupResponseHandler: AdministrationGroupResponseHandler;
    private billableServiceHandler: AdministrationBillableServiceHandler;
    private billableServiceResponseHandler: AdministrationBillableServiceResponseHandler;
    private adminTabHandler: AdministrationTabHandler;
    private sitesTabHandler: SitesTabHandler;
    private sitesTabResponseHandler: SitesTabResponseHandler;
    private logTabHandler: AdministrationLogHandler;
    private logTabResponseHandler: AdministrationLogResponseHandler;
    private administrationXComLogHandler: AdministrationXComLogHandler;

    public groupAction: AdministrationGroupAction;
    public serviceComboActions: ServiceComboAdministrationAction;
    public usersActions: AdministrationUsersAction;
    public billableServiceAction: AdministrationBillableServiceAction;
    public timeoutReferenceRefreshServices: number;
    public timeoutReferenceRefreshBillableServices: number;
    public sitesTabAction: SitesTabAction;
    public logTabAction: AdministrationLogAction;

    public adminTabModel: IAdminTabModel;
    public serviceComboGridModel: IServiceComboGridModel;
    public usersTabModel: IUsersTabModel;
    public groupTabModel: IGroupTabModel;
    public billableServiceTabModel: IBillableServiceModel;
    public sitesTabModel: ISitesTabModel;
    public siteViewModel: ISiteViewModel;
    public siteCreateModel: ISiteCreateModel;
    public logTabModel: ILogTabModel;
    public XComLogGridModel: IExternalConsultationHistoryGridModel;

    constructor() {
        super();

        var self = this;
        this.mapper = new RequestMapper();
        this.serverMapper = new ServerResponseMapper();
        this.adminTabHandler = new AdministrationTabHandler();
        this.mapper.AddInstance(this.adminTabHandler);

        this.serviceComboActions = new ServiceComboAdministrationAction();
        this.serviceComboHandler = new ServiceComboHandler();
        this.serviceComboResponseHandler = new ServiceComboResponseHandler(this.serviceComboActions);
        this.mapper.AddInstance(this.serviceComboHandler);
        this.serverMapper.AddInstance(this.serviceComboResponseHandler);

        this.usersHandler = new AdministrationUsersHandler();
        this.usersActions = new AdministrationUsersAction();
        this.usersResponseHandler = new AdministrationUsersResponseHandler(this.usersActions);

        this.grouphandler = new AdministrationGroupHandler();
        this.groupAction = new AdministrationGroupAction();
        this.groupResponseHandler = new AdministrationGroupResponseHandler(this.groupAction);

        this.mapper.AddInstance(this.usersHandler);
        this.serverMapper.AddInstance(this.usersResponseHandler);

        this.mapper.AddInstance(this.grouphandler);
        this.serverMapper.AddInstance(this.groupResponseHandler);

        this.billableServiceHandler = new AdministrationBillableServiceHandler();
        this.billableServiceAction = new AdministrationBillableServiceAction();
        this.billableServiceResponseHandler = new AdministrationBillableServiceResponseHandler(this.billableServiceAction);
        this.mapper.AddInstance(this.billableServiceHandler);
        this.serverMapper.AddInstance(this.billableServiceResponseHandler);

        this.sitesTabHandler = new SitesTabHandler();
        this.sitesTabAction = new SitesTabAction();
        this.sitesTabResponseHandler = new SitesTabResponseHandler(this.sitesTabAction);
        this.mapper.AddInstance(this.sitesTabHandler);
        this.serverMapper.AddInstance(this.sitesTabResponseHandler);

        this.logTabHandler = new AdministrationLogHandler();
        this.logTabAction = new AdministrationLogAction();
        this.logTabResponseHandler = new AdministrationLogResponseHandler(this.logTabAction);
        this.mapper.AddInstance(this.logTabHandler);
        this.serverMapper.AddInstance(this.logTabResponseHandler);

        this.administrationXComLogHandler = new AdministrationXComLogHandler();
        this.mapper.AddInstance(this.administrationXComLogHandler);

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => { self.serverMapper.Map(response, self); });
        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => self.mapper.Map(request, self));

        this.InitModels();
    }

    public static createSingleton(): AdministrationStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new AdministrationStore());
    }

    public static createSingletonFrom(store: AdministrationStore, copy: boolean = true): AdministrationStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }

    private InitModels(): void {
        this.adminTabModel = Immutable.fromJS(AdministrationHelper.GetDefaultForAdminTab());
        this.serviceComboGridModel = Immutable.fromJS(
            !!cacheStore.UserSettings?.ServiceComboDisplay
                ? AdministrationHelper.BuildServiceComboSearchGridModel(cacheStore.UserSettings.ServiceComboDisplay)
                : AdministrationHelper.GetDefaultServiceComboSearchGridModel()
        );
        this.usersTabModel = Immutable.fromJS(AdministrationHelper.GetDefaultUsersTab());
        this.groupTabModel = Immutable.fromJS(AdministrationHelper.GetDefaultGroupTab());
        this.billableServiceTabModel = Immutable.fromJS(AdministrationHelper.GetDefaultBillableServiceTab());
        this.logTabModel = Immutable.fromJS(AdministrationHelper.GetDefaultLogTabModel());
        this.sitesTabModel = SiteTabModel.getDefault();
        this.siteViewModel = SiteViewModel.getDefault();
        this.siteCreateModel = SiteCreateModel.getDefault();
        this.XComLogGridModel = Immutable.fromJS({});

        // defaults
        this.XComLogGridModel = this.XComLogGridModel
            .set("SearchText", "")
            .set("DateFrom", null)
            .set("DateTo", null)
            .set("EventTypes", [].toImmutable())
            .set("FileTypes", [].toImmutable())
            .set("EventDirections", [].toImmutable())
            .set("Options", [].toImmutable())
            .set("DateTo", null)
            .set("PageSelected", 1)
            .set("PageSize", 100);
    }
    // call this method to refresh the specializations in the search models of service and user models
    public updateServiceSearchSpecializations(): void {
        let sites = this.serviceComboGridModel.get("Sites").toArray();

        // set service search settings model
        let specializations = AdministrationHelper.GetSpecializationsBasedOnSites(sites);
        this.serviceComboGridModel = this.serviceComboGridModel.set("Specializations", Immutable.List(specializations));

        // set service search settings in Userstab model
        let userServiceModel = this.usersTabModel.get("UserServiceComboGridModel");
        userServiceModel = userServiceModel.set("Specializations", Immutable.List(AdministrationHelper.GetSpecializationsBasedOnSites(sites)));
        this.usersTabModel = this.usersTabModel.set("UserServiceComboGridModel", userServiceModel);
    }

    public updateUserInSearchSettings(): void {
        let sites = this.serviceComboGridModel.get("Sites").toArray();

        let specializations = AdministrationHelper.GetSpecializationsBasedOnSites(sites);

        // get employees to refresh service search settings
        let employeesCache = AdministrationHelper.GetEmployeeCache();
        employeesCache = AdministrationHelper.GetEmployeesBasedOnSpecialization(employeesCache, specializations);
        employeesCache.forEach(x => x.Checked = true);
        this.serviceComboGridModel = this.serviceComboGridModel.set("EmployeesGlobalCache", Immutable.List(employeesCache));
        this.serviceComboGridModel = this.serviceComboGridModel.set("EmployeesFiltered", Immutable.List(employeesCache));
    }

    public GetCostCentersSelectedSites(target: CheckboxTarget): Immutable.List<CostCenterUIModel> {
        let checkedSites = this.billableServiceTabModel.get("Sites").toArray().filter(x => x.Checked);
        let result: CostCenterUIModel[] = [];
        for (let site of checkedSites) {
            var filteredCostCenters = [];
            filteredCostCenters = cacheStore.CostCenterCache.filter(x => x.SiteId == site.Id);
            if (filteredCostCenters.length > 0) {
                for (let center of filteredCostCenters) {
                    var costCenter = cacheStore.getCostCenter(target, center);
                    result.push(costCenter);
                }
            }
        }
        return Immutable.List(result);
    }

    public loadUsersUICache(): void {
        let users = AdministrationHelper.GetEmployeeCacheForAdminLog();
        this.logTabModel = this.logTabModel.set("UsersGlobalCache", Immutable.List(users));
        this.logTabModel = this.logTabModel.set("UsersFiltered", this.getUsersBasedOnQuery());
    }

    public loadActionTypeCache(): void {
        this.logTabModel = this.logTabModel.set("ActionTypeCache", this.loadActionTypes());
        this.logTabModel = this.logTabModel.set("ActionTypeFiltered", this.getActionsBasedOnQuery());
    }

    public getUsersBasedOnQuery(): Immutable.List<EmployeeUIModel> {
        var clinicians = this.logTabModel.get("UsersGlobalCache");
        var filterString = this.logTabModel.get("UserSearchText") ? this.logTabModel.get("UserSearchText").trim() : "";
        if (filterString !== "") {
            clinicians = SearchMenuHelper.FilterCliniciansByName(filterString, clinicians);
        }
        return clinicians;
    }

    public getActionsBasedOnQuery(): Immutable.List<CheckboxUIModel> {
        let actionTypes = this.logTabModel.get("ActionTypeCache");
        let filterString = this.logTabModel.get("ActionSearchText") ? this.logTabModel.get("ActionSearchText").trim() : "";
        if (filterString !== "") {
            actionTypes = actionTypes.toArray().filterSearch(filterString, x => x.Name).toImmutable();
        }
        return actionTypes;
    }

    public areLogDateFieldsValid(): boolean {
        const model = this.logTabModel;
        if (model) {
            let dateFrom = model.get("DateFrom") ? moment(model.get("DateFrom")) : null;
            let dateTo = model.get("DateTo") ? moment(model.get("DateTo")) : null;
            if (dateFrom && dateTo && (dateTo.isBefore(dateFrom) || dateTo.diff(dateFrom, "years", true) >= 1))
                return false;
        }
        return true;
    }

    public getLogDateRangeErrorMessage(): string {
        let model = this.logTabModel;
        if (model) {
            let dateFrom = model.get("DateFrom") ? moment(model.get("DateFrom")) : null;
            let dateTo = model.get("DateTo") ? moment(model.get("DateTo")) : null;

            if (!dateFrom || !dateTo)
                return cacheStore.GetString("Administration_Logs_FromDateAndToDateShouldNotBeNull");

            if (dateFrom && dateTo) {
                if (dateTo.isBefore(dateFrom))
                    return cacheStore.GetString("Administration_Logs_ToDateCannotBeSmallerThanFromDate");

                if (dateTo.diff(dateFrom, "years", true) >= 1)
                    return cacheStore.GetString("Administration_Logs_DatePeriodFilterShouldBeOneYearMaximum");
            }
        }
        return "";
    }

    public areLogAccessReportFieldsValid(): boolean {
        let model = this.logTabModel;
        if (model) {
            if (model.get("IsAccessReportSelected")) {
                let nbAccess = model.get("NbAccess");
                let interval = model.get("Interval");

                if (nbAccess == null || interval == null)
                    return false;

                if (nbAccess === 0 || interval === 0)
                    return false;
            }
        }
        return true;
    }

    private loadActionTypes(): Immutable.List<CheckboxUIModel> {
        let actionTypes: CheckboxUIModel[] = [];
        for (let key in LogEventTypeEnum) {
            let value = Number(key);

            value = this.mergePharmacyAndPdfGeneratedMedicalSummaryLogActionValue(key, value);
            if (actionTypes.some(action => action.Id === `${value}`)) {
                continue; // Avoid duplicates
            }

            if (!isNaN(value)) {
                let actionType = new CheckboxUIModel();
                actionType.Id = `${value}`;
                actionType.Name = AdministrationHelper.convertEventTypeEnumToString(value);
                actionType.Target = CheckboxTarget.Myle_Admin_Log_ActionTypes_Check;
                actionType.Checked = false;

                actionTypes.push(actionType);
            }
        }
        return Immutable.List(actionTypes);
    }

    public loadFilteredActionsBasedOn(actions: Immutable.List<CheckboxUIModel>): Immutable.List<CheckboxUIModel> {
        if (!actions)
            return Immutable.List([]);

        let actionTypes = [];
        for (let key in LogEventTypeEnum) {
            let value = Number(key);

            value = this.mergePharmacyAndPdfGeneratedMedicalSummaryLogActionValue(key, value);
            if (actionTypes.some(action => action.Id === `${value}`)) {
                continue; // Avoid duplicates
            }

            if (!isNaN(value)) {
                let action = actions.toArray().filter(x => x.Id === `${value}`).firstOrDefault();
                if (action) {
                    action.Name = AdministrationHelper.convertEventTypeEnumToString(value);

                    actionTypes.push(action);
                }
            }
        }
        return Immutable.List(actionTypes);
    }

    private mergePharmacyAndPdfGeneratedMedicalSummaryLogActionValue(key: string, value: number): number {
        if (key === LogEventTypeEnum.PharmacyPatientConsentedSharingMedicalSummary.toString() || key === LogEventTypeEnum.PdfGenerated_MedicalSummary.toString()) {
            return Number(LogEventTypeEnum.PdfGenerated_MedicalSummary);
        }
        return value;
    }
}

export { AdministrationStore, defaultInstance as administrationStore };
